import { PageNotFoundContainer, Title, Subtitle } from './styled';
import { useNavigate } from 'react-router';

function PageNotFound() {
    const navigate = useNavigate();

    return (
        <PageNotFoundContainer>
            <Title>Page Not Found</Title>
            <Subtitle>
                We are Profoundly sorry about that. Something seems to have gone
                wrong.
            </Subtitle>
            <button className="primary-button" onClick={() => navigate('/')}>
                Home Page
            </button>
        </PageNotFoundContainer>
    );
}

export default PageNotFound;
